<template>
  <svg width="30" height="30" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_2204_6353)">
      <path
        d="M35.8747 22.0697V33.333H37.583V36.6663H3.41634V33.333H5.12468V22.0697C4.07298 21.3848 3.21085 20.4572 2.61483 19.3693C2.0188 18.2813 1.70731 17.0666 1.70801 15.833C1.70801 14.4547 2.09068 13.1263 2.78938 11.9947L7.42238 4.16634C7.57232 3.91298 7.78797 3.70259 8.04766 3.55631C8.30735 3.41003 8.60193 3.33302 8.9018 3.33301H32.0993C32.3991 3.33302 32.6937 3.41003 32.9534 3.55631C33.2131 3.70259 33.4287 3.91298 33.5787 4.16634L38.1946 11.9697C39.2137 13.6211 39.5413 15.5922 39.1092 17.4732C38.6772 19.3543 37.5187 21.0005 35.8747 22.0697V22.0697ZM32.458 23.2863C31.2834 23.4149 30.0943 23.2772 28.9831 22.8841C27.872 22.491 26.8688 21.8529 26.0518 21.0197C25.3346 21.7515 24.4729 22.3339 23.5187 22.7318C22.5644 23.1296 21.5374 23.3347 20.4997 23.3347C19.4622 23.3352 18.4353 23.1306 17.4811 22.7333C16.5269 22.336 15.665 21.7542 14.9476 21.023C14.1304 21.856 13.1271 22.4937 12.016 22.8865C10.9049 23.2794 9.7158 23.4168 8.54134 23.288V33.333H32.458V23.288V23.2863ZM9.88922 6.66634L5.73284 13.688C5.32895 14.6616 5.31683 15.7481 5.6989 16.73C6.08097 17.7119 6.82904 18.5168 7.7934 18.9837C8.75776 19.4505 9.86726 19.5448 10.8998 19.2477C11.9324 18.9506 12.8119 18.284 13.3623 17.3813C13.9346 15.9863 15.9589 15.9863 16.5329 17.3813C16.8495 18.1554 17.3967 18.819 18.1038 19.2865C18.8109 19.754 19.6455 20.0039 20.4997 20.0039C21.3539 20.0039 22.1884 19.754 22.8956 19.2865C23.6027 18.819 24.1499 18.1554 24.4664 17.3813C25.0387 15.9863 27.0631 15.9863 27.6371 17.3813C27.8588 17.9138 28.191 18.3957 28.6128 18.7968C29.0346 19.1979 29.5369 19.5096 30.0881 19.7122C30.6393 19.9148 31.2275 20.004 31.8158 19.9741C32.404 19.9443 32.9796 19.796 33.5063 19.5387C34.0329 19.2814 34.4994 18.9206 34.8762 18.4789C35.2531 18.0372 35.5322 17.5243 35.6961 16.9723C35.86 16.4203 35.905 15.8412 35.8285 15.2714C35.7519 14.7016 35.5553 14.1535 35.2511 13.6613L31.1084 6.66634H9.89093H9.88922Z"
        :fill="secondaryColor" />
    </g>
    <defs>
      <clipPath id="clip0_2204_6353">
        <rect width="41" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>

</template>

<script>
export default {
  name: "storeIcon",
  computed: {
    secondaryColor() {
      return this.$vuetify.theme.currentTheme.secondary;
    },
  },
};
</script>

<style scoped>

</style>
